/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SortingSortingKey { 
    sortBy?: SortingSortingKey.SortByEnum;
    sortDirection?: SortingSortingKey.SortDirectionEnum;
}
export namespace SortingSortingKey {
    export type SortByEnum = 'LAST_DATA_CHANGE' | 'LAST_STRUCTURE_CHANGE';
    export const SortByEnum = {
        DataChange: 'LAST_DATA_CHANGE' as SortByEnum,
        StructureChange: 'LAST_STRUCTURE_CHANGE' as SortByEnum
    };
    export type SortDirectionEnum = 'DESC' | 'ASC';
    export const SortDirectionEnum = {
        Desc: 'DESC' as SortDirectionEnum,
        Asc: 'ASC' as SortDirectionEnum
    };
}


